import * as React from 'react';
import { useDayPicker } from '../../contexts';
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
export function Dropdown(props) {
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, IconDropdown = _a.components.IconDropdown;
    return (React.createElement("div", { className: className, style: style },
        React.createElement("span", { className: classNames.vhidden }, props['aria-label']),
        React.createElement("select", { "aria-label": props['aria-label'], className: classNames.dropdown, style: styles.dropdown, value: value, onChange: onChange }, children),
        React.createElement("div", { className: classNames.caption_label, style: styles.caption_label, "aria-hidden": "true" },
            caption,
            React.createElement(IconDropdown, { className: classNames.dropdown_icon, style: styles.dropdown_icon }))));
}
//# sourceMappingURL=Dropdown.js.map